import SlotsBetHistory from './SlotsBetHistory';

export default SlotsBetHistory;
